import Vue from 'vue';

export default {

  async fetchLatestMatches() {
    try {
      const response = await Vue.http.get('https://www.openligadb.de/api/getmatchdata/rlbay');
      if (response.status !== 200) {
        throw new Error(`Got status code ${response.status}. Abort.`);
      }
      return response.body;
    } catch (error) {
      throw error;
    }
  },

  async fetchTableData() {
    try {
      const response = await Vue.http.get('https://www.openligadb.de/api/getbltable/rlbay/2017');
      if (response.status !== 200) {
        throw new Error(`Got status code ${response.status}. Abort.`);
      }
      return response.body;
    } catch (error) {
      throw error;
    }
  },

  getShortTeamName(name) {
    switch (name) {
      case 'TSV 1860 München':
        return 'TSV 1860';
      case 'FC Bayern München II':
        return 'München B II';
      case '1. FC Nürnberg II':
        return 'Nürnberg II';
      case 'FC Ingolstadt 04 II ':
        return 'Ingolstadt II';
      case '1. FC Schweinfurt 05':
        return 'Schweinfurt';
      case 'FV Illertissen':
        return 'Illertissen';
      case 'SV Schalding-Heining':
        return 'Schalding-Heining';
      case 'Wacker Burghausen':
        return 'Burghausen';
      case 'TSV 1860 Rosenheim':
        return 'Rosenheim';
      case 'FC Augsburg II':
        return 'Augsburg II';
      case 'TSV Buchbach':
        return 'Buchbach';
      case 'VfB Eichstätt':
        return 'Eichstätt';
      case 'FC Pipinsried':
        return 'Pipinsried';
      case 'VfR Garching':
        return 'Garching';
      case 'SpVgg Greuther Fürth II':
        return 'Fürth II';
      case 'SpVgg Oberfranken Bayreuth':
        return 'Bayreuth';
      case 'SV Seligenporten':
        return 'Seligenporten';
      case 'FC Memmingen':
        return 'Memmingen';
      case 'FC Unterföhring':
        return 'Unterföhring';
      default:
        return name;
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/openLigaDb.js